import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import { Radio } from '@delmonicos/shared-design-system-react/src/components/radio/radio';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TokenType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/enums/token/token-type.enum';
import { useTranslation } from 'react-i18next';

interface TokenTypeFilterControllerProps {
  onChange: (item?: TokenType) => void;
  selectedItem?: TokenType;
}

export const TokenTypeFilterController = ({
  onChange,
  selectedItem,
}: TokenTypeFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const tokenTypeList = Object.values(TokenType).map((type) => ({
    key: type,
    value: type,
  }));

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="electric-car-2"
        text={t('delmonicos-shared-sdk.outputs-token.type')}
      />
      <Stack gap={GapEnum.S} direction="column">
        {tokenTypeList.map((tokenType) => (
          <Radio
            key={tokenType.key}
            label={tokenType.value}
            checked={selectedItem === tokenType.key}
            onChange={() => onChange(tokenType.key)}
          />
        ))}
      </Stack>
    </Stack>
  );
};
